import HttpClient from "../../clients/HttpClient";
import InAppMessage from "../../models/InAppMessage";
import InAppMessageListItem from "../../models/InAppMessageListItem";

export default class InAppMessagesService {
    static httpClient: HttpClient = HttpClient.getInstance("backend", process.env.REACT_APP_API_URL);

    // Global list - returns all messages
    public static async list(params = {}): Promise<Array<InAppMessageListItem>> {
        return this.httpClient.get("/in_app_messages", params).then((res) => {
            return res.data.map((row) => new InAppMessageListItem(row));
        });
    }

    // User list - returns only non-dismissed messages
    public static async userList(userId: number): Promise<Array<InAppMessage>> {
        return this.httpClient.get(`/users/${userId}/in_app_messages`).then((res) => {
            return res.data.map((row) => new InAppMessage(row));
        });
    }

    public static async getInAppMessage(id): Promise<InAppMessage> {
        return this.httpClient.get(`/in_app_messages/${id}`).then((res) => {
            return new InAppMessage(res.data);
        });
    }

    public static async addInAppMessage(data): Promise<InAppMessage> {
        // Placing these here in service layer due to GenericTable and GenericForm has no way to inject code
        // before add/edit is called on the service.
        _stringifyPayload(data);

        return this.httpClient.post(`/in_app_messages`, data).then((res) => {
            return new InAppMessage(res.data);
        });
    }

    public static async editInAppMessage(id, data): Promise<InAppMessage> {
        // Placing these here in service layer due to GenericTable and GenericForm has no way to inject code
        // before add/edit is called on the service.
        _stringifyPayload(data);

        return this.httpClient.put(`/in_app_messages/${id}`, data).then((res) => {
            return new InAppMessage(res.data);
        });
    }

    public static async viewedInAppMessage(id, viewed: boolean = true): Promise<InAppMessage> {
        return this.httpClient.put(`/in_app_messages/${id}/viewed/${viewed ? 1 : 0}`, {}).then((res) => {
            return new InAppMessage(res.data);
        });
    }

    public static async dismissInAppMessage(id, dismissed: boolean = true): Promise<InAppMessage> {
        return this.httpClient.put(`/in_app_messages/${id}/dismissed/${dismissed ? 1 : 0}`, {}).then((res) => {
            return new InAppMessage(res.data);
        });
    }

    public static async deleteInAppMessage(id): Promise<boolean> {
        return this.httpClient.delete(`/in_app_messages/${id}`, null).then((res) => {
            return true;
        });
    }
}

function _stringifyPayload(data) {
    data.title = data.title ? JSON.stringify(data.title) : null;
    data.shortBody = data.shortBody ? JSON.stringify(data.shortBody) : null;
    data.longBody = data.longBody ? JSON.stringify(data.longBody) : null;
}
